export default {
    // apiBaseURL: 'https://cca-api.dierqudao.com/',
    apiBaseURL: 'https://api.ccachina.net/',
    // apiBaseURL: 'http://api.cca.net',
    wsBaseURL: 'wss://api-test.cca.dierqudao.com/wss',

    pcBaseURL: 'https://pc.ccachina.net',
}